import {
  NOTIFICATION_CHANNEL,
  DEFAULT_NOTIFICATION_RULES,
  resolveDefaultNotificationRecipientIds,
  resolveDefaultPiRoleId,
} from "./isfMilestoneService";
import { normalizeFolderCategory } from "./isfFolderLibraryService";

export const MILESTONE_NAME_MAX_LENGTH = 50;

export const resolveMilestoneFolderCategory = (milestone, folderOptions = []) => {
  if (!milestone) return "eISF";

  const explicit =
    milestone.DefaultFolderCategory ?? milestone.defaultFolderCategory;
  if (explicit != null && String(explicit).trim() !== "") {
    return normalizeFolderCategory(explicit);
  }

  const folderName =
    milestone.DefaultFolderName ?? milestone.defaultFolderName ?? "";
  if (!folderName) return "eISF";

  const matches = folderOptions.filter(
    (opt) => opt.value === folderName || opt.label === folderName,
  );
  if (matches.length === 1) {
    return normalizeFolderCategory(matches[0].folderCategory);
  }

  return "eISF";
};

export const milestoneMatchesFolderCategory = (
  milestone,
  category,
  folderOptions = [],
) => {
  const normalizedCategory = normalizeFolderCategory(category);

  const explicit =
    milestone?.DefaultFolderCategory ?? milestone?.defaultFolderCategory;
  if (explicit != null && String(explicit).trim() !== "") {
    return normalizeFolderCategory(explicit) === normalizedCategory;
  }

  const folderName =
    milestone?.DefaultFolderName ?? milestone?.defaultFolderName ?? "";
  if (!folderName) return normalizedCategory === "eISF";

  return folderOptions.some(
    (opt) =>
      (opt.value === folderName || opt.label === folderName) &&
      normalizeFolderCategory(opt.folderCategory) === normalizedCategory,
  );
};

export const emptyMilestoneForm = (notificationRoles = []) => {
  const piRoleId = resolveDefaultPiRoleId(notificationRoles);
  const piRoles = piRoleId ? piRoleId : "";

  return {
  MilestoneCode: "",
  MilestoneName: "",
  Description: "",
  Category: "Clinical",
  GateCode: "PRE_STUDY",
  Tags: "",
  DefaultFolderName: "",
  DefaultFolderCategory: "eISF",
  DefaultUploaderRoles: piRoles,
  DefaultSignerRoles: piRoles,
  RequiresSignature: true,
  AllowsNotApplicable: false,
  IsInformational: false,
  records: [],
  AnchorType: "ReferenceDate",
  AnchorMilestoneCode: "",
  AnchorOffsetDays: "7",
  notifications: DEFAULT_NOTIFICATION_RULES(
    resolveDefaultNotificationRecipientIds(notificationRoles),
  ),
};
};
export const normalizeMilestoneNotificationRow = (row, index) => ({
  TriggerCode: row.TriggerCode || "",
  TriggerLabel: row.TriggerLabel || "",
  DefaultRecipients: row.DefaultRecipients || "",
  Channel: NOTIFICATION_CHANNEL,
  IsEnabled: row.IsEnabled !== false && row.IsEnabled !== 0,
  SortOrder: row.SortOrder ?? index,
});

export const normalizeOffsetDigits = (value) =>
  String(value ?? "").replace(/\D/g, "");

/** Signed offset for milestone date formula (digits only in input; sign via +/- toggle). */
export const parseMilestoneOffset = (value) => {
  if (value === "" || value == null) {
    return { sign: "+", digits: "" };
  }
  const raw = String(value).trim();
  const negative = raw.startsWith("-") || Number(raw) < 0;
  const digits = raw.replace(/\D/g, "");
  return { sign: negative ? "-" : "+", digits };
};

export const composeMilestoneOffset = (sign, digits) => {
  const clean = String(digits ?? "").replace(/\D/g, "");
  if (!clean) return "";
  const n = Number(clean);
  if (Number.isNaN(n)) return "";
  return sign === "-" ? -n : n;
};

export const formatMilestoneOffsetForForm = (value) => {
  if (value === "" || value == null) return "";
  const n = Number(value);
  if (Number.isNaN(n)) return "";
  return String(n);
};
